import { Component, OnInit } from '@angular/core';
import { EventService } from '@reenstudio/app/core/services/event-service';

@Component({
  selector: 'app-monitoring-page',
  templateUrl: './monitoring-page.component.html',
  styleUrls: ['./monitoring-page.component.scss'],
})
export class MonitoringPageComponent implements OnInit {
  site: number = 0;

  ngOnInit() {
    EventService.pageFilters.subscribe((data) => {
      this.site = data.site;
    });
  }

  //TODO Implementare get dei dati per i widget in modo da fare una sola chiamata e distribuire i dati ai vari components
}
